import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MyThunkDispatch, RootState } from 'store';

import { getCompanyConfigurationFromDomain } from 'actions/companyConfiguration';
import { fetchRestCountryList } from 'actions/i18n';
import { onUserLogout } from 'actions/user';
import useEmergencyMessage from 'hooks/useEmergencyMessage';
import Login from 'screens/components/Login';
import { LoadingContainer, LoadingSpinner } from 'screens/components/Login/styles';
import { verifyInviteExists, resendInvite } from 'services/loginService';
import { resendTwoFactor } from 'services/otpService';
import { verifyLinkedRappiUser, VerifyLinkedRappiUserParameters } from 'services/registrationService';

const LoginContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();
  const emergencyMessage = useEmergencyMessage();

  const { restCountries } = useSelector((state: RootState) => state.i18n);
  const { isLoading } = useSelector((state: RootState) => state.companyConfiguration);
  const [initialLoading, setInitialLoading] = useState<boolean>(true);

  const fetchCountryCodes = () => dispatch(fetchRestCountryList());
  const verifyInvite = (email: string) => verifyInviteExists(email);
  const verifyLinkedUser = (data: VerifyLinkedRappiUserParameters) => verifyLinkedRappiUser(data);
  const resend = (email: string) => resendInvite(email);
  const resendTwoFactorAuth = (key: string) => resendTwoFactor(key);

  useEffect(() => {
    emergencyMessage.reset();
  }, [emergencyMessage]);

  useEffect(() => {
    dispatch(onUserLogout());
    dispatch(getCompanyConfigurationFromDomain(`${window.location.protocol}//${window.location.host}/corporate`));
    setInitialLoading(false);
  }, []);

  return !initialLoading && !isLoading ? (
    <Login
      fetchCountryCodes={fetchCountryCodes}
      restCountries={restCountries}
      loadingRestCountries={isLoading}
      verifyInviteExists={verifyInvite}
      verifyLinkedUser={verifyLinkedUser}
      resendInvite={resend}
      resendTwoFactor={resendTwoFactorAuth}
    />
  ) : (
    <LoadingContainer>
      <LoadingSpinner />
    </LoadingContainer>
  );
};

export default LoginContainer;
